import { BaseDividerType } from "../types"

export default function BaseDivider({ classProps, light }: BaseDividerType) {
    return <div className={`${classProps ?? "mt-8 mb-8"} ${light ? "border-b" : "border-b-2 !border-black"} w-full`} />
}
